module.exports = __webpack_public_path__ + "static/eslamhesham-adf9aea0d7815c09125aee6084d430ad.jpg";